import { render } from "./series-popup.vue?vue&type=template&id=226d2f9d"
import script from "./series-popup.vue?vue&type=script&lang=js"
export * from "./series-popup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__